import { Component, OnInit, Input, ContentChildren, QueryList, Renderer2, ViewContainerRef, Output, EventEmitter, ElementRef, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { DatePickerComponent } from 'ngx-bootstrap/datepicker';
import { NdmsFormControlComponent } from '../ndms-form-control/ndms-form-control.component';
import { HasFormComponent } from '../../../core/interfaces/hasFormComponent';

@Component({
  selector: 'ndms-panel-form',
  templateUrl: './ndms-panel-form.component.html',
  styleUrls: ['./ndms-panel-form.component.scss']
})
export class NdmsPanelFormComponent implements OnInit {

  @Input() public label: string;
  @Input() public group: FormGroup;
  @Input() public service: any;
  @Input() public saveFnName: string;
  @Input() public useSaveIcon: boolean = true;
  @Input() public saveButtonTitle: string = "save";
  @Input() public helpMsgText: string;
  @Input() public buttonOverride: boolean = false;
  @Input() public canSave: (formGroupData: any) => boolean;
  @Input() public disableCancel: boolean = false;
  @Input() public editEnabled: boolean = true;
  @Input() public closeClearState: boolean = true;
  @Input() public disableOnSave:boolean = false;
  @Output() public buttonClick = new EventEmitter();
  @Output() public onCancelClick = new EventEmitter();
  @Output() public onEditClick = new EventEmitter();

  @ContentChildren('control') formControls: QueryList<NdmsFormControlComponent>;

  isSaving: boolean;
  saveDisabled: boolean = false;
  SaveState = SaveState;
  formSaveState: SaveState;
  initFormValue: any;
  isInitTabSubscriptions: boolean;
  hasFormComponent: HasFormComponent<any>;

  constructor(private renderer: Renderer2, vcRef: ViewContainerRef) {
    this.hasFormComponent = (<any>vcRef.injector).view.component;
  }

  get isEditing(): boolean {
    return this.hasFormComponent.isEditing;
  }

  set isEditing(value: boolean) {
    this.hasFormComponent.isEditing = value;
  }

  ngOnInit() {

  }

  onEdit() {
    this.initFormValue = this.group.value;
    this.isEditing = !this.hasFormComponent.isEditing;
    this.onEditClick.emit({shouldEdit:this.isEditing});
    if (this.isEditing) {
      if (!this.isInitTabSubscriptions) {
        this.isInitTabSubscriptions = true;
      }
    }
  }
  onCancelClickMethod() {
    this.group.patchValue(Object.assign({},this.group.value,this.initFormValue));
    if(this.group.get('statusChangeReason')){
      this.group.removeControl('statusChangeReason')
    }

    this.isEditing = false;
    this.formSaveState = this.SaveState.IDLE;

    this.onCancelClick.emit();
  }
  onSaveClick() {


    if (!this.hasFormComponent.isFormValid()) {
      let errors = Object.keys(this.group.controls).filter(i=> !this.group.controls[i].valid);
      return;
    }
    if(this.disableOnSave){
      this.saveDisabled = true;
    }
    if (this.buttonOverride) {
      this.buttonClick.emit(this.group.value);
      return;
    }
    if(this.canSave && !this.canSave(this.group.value)){
      return;
    }

    this.isSaving = true;
    (this.service[this.saveFnName](this.group.value) as Observable<any>).subscribe(
      (success: any) => {
          this.isEditing = false;
          this.formSaveState = this.SaveState.SUCCESS;
          setTimeout(() => {
            this.isSaving = false;
            this.formSaveState = this.SaveState.IDLE;
          }, 1500);
          this.buttonClick.emit(this.group.value);
      },
      (error: any) => {
        console.log('save error', error);
        this.saveDisabled = false;
        this.isEditing = true;
        this.isSaving = false;
        this.formSaveState = this.SaveState.ERROR;
      })
  }
}

export enum SaveState {
  IDLE,
  SUCCESS,
  INFO,
  ERROR
}
